import { render, staticRenderFns } from "./PxyjfkForm.vue?vue&type=template&id=53b49363"
import script from "./PxyjfkForm.vue?vue&type=script&lang=js"
export * from "./PxyjfkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports